<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M11.1 4.4q.9-.7 1.8 0l6.7 6.7q.8.9 0 1.8L13 19.6a1.3 1.3 0 1 1-1.8-1.8L17 12l-6-5.8q-.7-.9 0-1.8"
    />
    <path
      d="M4.4 4.4q.9-.7 1.8 0l6.7 6.7q.7.9 0 1.8l-6.7 6.7a1.3 1.3 0 1 1-1.8-1.8l5.8-5.8-5.8-5.8q-.7-.9 0-1.8"
    />
  </svg>
</template>
